/**
 * While scrolling, mark the editor so CSS can switch off hover work
 * (drag-handle mouseenter churn + :has() hover restyles as content slides
 * under the cursor are what make scrollbar-dragging feel jittery).
 */

import { useEffect } from 'react';

export function useEditorScrollChrome(editorRootRef) {
  useEffect(() => {
    const root = editorRootRef.current;
    if (!root) return undefined;
    let timer = null;
    const onScroll = (e) => {
      if (!e.target?.contains?.(root)) return; // only our scroll containers
      root.classList.add('doc-editor--scrolling');
      if (timer) clearTimeout(timer);
      // Stay up across wheel notches. A short gap lets :hover / :has()
      // restyle the whole doc between ticks, which reads as a stutter.
      timer = setTimeout(() => root.classList.remove('doc-editor--scrolling'), 400);
    };
    document.addEventListener('scroll', onScroll, { capture: true, passive: true });
    return () => {
      document.removeEventListener('scroll', onScroll, { capture: true });
      if (timer) clearTimeout(timer);
    };
  }, [editorRootRef]);
}
